__webpack_require__.p = "/reports-migrate-view-dashboards-permission/referrals-hub/";